import {useSearchParams} from "react-router-dom"
import {z} from "src/lib";
import {NuevoSistemaWRCredito, NuevoSistemaWRMercado} from "./sistemas";
import Error404 from "../404";
import {NuevoSistemaContraparte} from "./sistemas/contraparte/NuevoSistemaContraparte";
import {NuevaOperacionLayout} from "./layout/NuevaOperacionLayout";
import {createContext, useState} from "react";
import {NuevoSistemaCLG} from "./sistemas/clg/NuevoSistemaCLG";
import {NuevoSistemaCLFB} from "./sistemas/clfb/NuevoSistemaCLFB";
import {NuevoSistemaCorporate} from "./sistemas/corporate/NuevoSistemaCorporate";
import NuevoSistemaCapitalMarkets from "./sistemas/capital_markets/NuevoSistemaCapitalMarkets";
import {NuevoSistemaNotaEstructurada} from "./sistemas/nota_estructurada/NuevoSistemaNotaEstructurada";
import NuevoSistemaTransferenciaTerceros from "./sistemas/transferencia-terceros/NuevoSistemaTransferenciaTerceros";
import NuevoSistemaCorporateLending from "./sistemas/corporate_lending/NuevoSistemaCorporateLending";
import NuevoSistemaControlOperativo from "./sistemas/control-operativo/NuevoSistemaControlOperativo";
import NuevoSistemaLEP from "./sistemas/lep/NuevoSistemaLEP";
import NuevoSistemaLCLS from "./sistemas/lcls/NuevoSistemaLCLS";
import NuevoSistemaLCTC from "./sistemas/lctc/NuevoSistemaLCTC";
import NuevoSistemaAFOPU from "./sistemas/afopu/NuevoSistemaAFOPU";
import NuevoSistemaAFOCL from "./sistemas/afocl/NuevoSistemaAFOCL";
import NuevoSistemaLCSLHPTI from "./sistemas/lcslhpti/NuevoSistemaLCSLHPTI";
import NuevoSistemaNOTES from "./sistemas/notes/NuevoSistemaNOTES";
import NuevoSistemaADCM from "./sistemas/adcm/NuevoSistemaADCM";
import NuevoSistemaADL from "./sistemas/adl/NuevoSistemaADL";

// const SchemaFields = {
//     SistemaPrincipal: MensajeFields.CodigoSistemaPrincipal,
//     Sistema: MensajeFields.MensajeTipo
// } as const

const schema = z.object({
    sistemaPrincipal: z.coerce.number(),
    sistemaTipo: z.coerce.number(),
    sistema: z.coerce.number(),
})

// type Schema = z.infer<typeof schema>

const getPantallaPorSistema = (codTipoOperacion: number) => {
    switch (codTipoOperacion) {
        case 2:
            return NuevoSistemaWRCredito;
        case 3:
            return NuevoSistemaWRMercado;
        case 4:
            return NuevoSistemaContraparte;
        case 7:
            return NuevoSistemaCLG;
        case 8:
            return NuevoSistemaCLFB;
        case 10:
            return NuevoSistemaCorporate;
        case 11:
            return NuevoSistemaCapitalMarkets;
        case 12:
            return NuevoSistemaNotaEstructurada;
        case 13:
            return NuevoSistemaTransferenciaTerceros;
        case 14:
            return NuevoSistemaCorporateLending;
        case 15:
            return NuevoSistemaControlOperativo;
        case 16:
            return NuevoSistemaLEP;
        case 17:
            return NuevoSistemaLCLS;
        case 18:
            return NuevoSistemaLCTC;
        case 19:
            return NuevoSistemaAFOPU;
        case 20:
            return NuevoSistemaAFOCL;
        case 21:
            return NuevoSistemaLCSLHPTI;
        case 22:
            return NuevoSistemaNOTES;
        case 23:
            return NuevoSistemaADCM;
        case 24:
            return NuevoSistemaADL;
        default:
            return () => <Error404/>
    }
};

export type ContextOperacionNuevoType = {
    setSavePromise: React.Dispatch<React.SetStateAction<(() => void) | undefined>>
    setSendPromise: React.Dispatch<React.SetStateAction<(() => void) | undefined>>
    codSistema: number
    codSistemaPrincipal: number
    codSistemaTipo: number
};

export const ContextOperacionNuevo = createContext<ContextOperacionNuevoType>({
    setSavePromise: console.log,
    setSendPromise: console.log,
    codSistema: 0,
    codSistemaPrincipal: 0,
    codSistemaTipo: 0,
});


const PaginaOperacionNuevo = ({
                                  codSistema,
                                  codSistemaPrincipal,
                                  codSistemaTipo,
                                  children
                              }: { codSistema: number, codSistemaPrincipal: number, codSistemaTipo: number, children: React.ReactNode }) => {

    const [savePromise, setSavePromise] = useState<() => void>()
    const [sendPromise, setSendPromise] = useState<() => void>()

    return (
        <NuevaOperacionLayout
            acciones={{
                saveHandler: savePromise,
                sendHandler: sendPromise
            }}
            codSistema={codSistema}
            codSistemaPrincipal={codSistemaPrincipal}
            codSistemaTipo={codSistemaTipo}
        >
            <ContextOperacionNuevo.Provider value={{
                setSavePromise,
                setSendPromise,
                codSistema: codSistema,
                codSistemaPrincipal: codSistemaPrincipal,
                codSistemaTipo: codSistemaTipo,
            }}
            >
                {children}
            </ContextOperacionNuevo.Provider>
        </NuevaOperacionLayout>
    )
}

export const NuevoSistema = () => {

    const [searchParams] = useSearchParams()

    const rawQueryParams = Object.fromEntries(searchParams.entries());

    const parsed = schema.safeParse(rawQueryParams)

    if (!parsed.success) {
        console.log(parsed)

        return <Error404/>
    } else {
        const SistemaPantalla = getPantallaPorSistema(parsed.data.sistemaTipo);

        return (
            <PaginaOperacionNuevo
                codSistema={parsed.data.sistema}
                codSistemaPrincipal={parsed.data.sistemaPrincipal}
                codSistemaTipo={parsed.data.sistemaTipo}
            >
                {SistemaPantalla && <SistemaPantalla
                    codSistemaPrincipal={parsed.data.sistemaPrincipal}/>}
            </PaginaOperacionNuevo>
        )
    }
}
